import { useMemo } from 'react'
import useFilters from 'views/hooks/useFilters'
import { Filter, FilterState } from 'views/components/Filters'
import { useManualAdjustmentReasonsQuery, ManualAdjustmentReasonType } from '../../../../../graphql'
import { heapEvent } from '@equipmentshare/heaper'

export function buildReasonVariables( filterState: FilterState ) {
	const reasons: ManualAdjustmentReasonType[] = []

	filterState.forEach( ( filterOption ) => {
		if ( filterOption.checked === 'on' ) {
			reasons.push( filterOption.key as ManualAdjustmentReasonType )
		}
	} )

	return { reasons }
}

export function onFilterChange( args: { filter: string, value: boolean } ) {
	heapEvent( 'Inventory - Inventory Adjustments - Change - Filters', args )
}

export function useReasons() {
	const { data } = useManualAdjustmentReasonsQuery()

	if ( data?.manualAdjustmentReasons ) {
		return data.manualAdjustmentReasons.map( ( r ) => ( {
			label: r?.description as string,
			value: r?.reason as string
		} ) )
	}
	return []
}

export default function useReasonFilter() {
	const { data, loading } = useManualAdjustmentReasonsQuery()

	const reasons = useMemo<Filter[]>( () => {
		if ( data?.manualAdjustmentReasons ) {
			return data.manualAdjustmentReasons.map( ( r ) => ( {
				key: r?.reason,
				label: r?.description,
				initialValue: false,
			} ) ).filter( ( r ) => !!r.key && !!r.label ) as Filter[]
		}
		return []
	}, [ data ] )

	 const { render, ...result } = useFilters( 'inventoryAdjustments', reasons, buildReasonVariables, onFilterChange, 'Reason' )

	 return {
		...result,
		loading,
		render: () => render( loading ),
	 }
}
